import * as React from 'react';
import { useEffect, useState } from 'react';
import store from 'src/storeWire';
import { system_notification } from 'src/store/slice/system';
import { useQuoteDetailStore } from 'src/hooks/quote-detail';
import { Pagination } from 'src/reusable/global';
import "floating-scroll";
import System from 'src/helper/system';
import Helper from 'src/support/Helper';
import { useAxiosIndicatorCheck } from 'src/store/hook/useAxiosIndicatorCheck';
import { useQuoteFilterSelectionStore } from 'src/hooks/component/quote-filter-selection';
import { isArray, isNumber, isObject } from "underscore";
import CommonQuoteDetail from 'src/pages/QuoteDetail/CommonQuoteDetail';
import ProductLegends from 'src/pages/ProductListing/ProductLegends';
import useReduxState from "../../../hooks/useReduxState";
import { useSearchParams } from "react-router-dom";
import ProductInventoryRepository from 'src/repository/ProductInventoryRepository';
import RefreshStockButton from 'src/pages/ProductListing/RefreshStockButton';
import produceClone from "src/helper/produceClone";
import NoResultContent from 'src/pages/HomePageContent/NoResultContent';
import ShowMoreLess from 'src/component/Product/ShowMoreLess';
import QuoteDetailRepository from 'src/repository/QuoteDetailRepository';
import usePreviousState from "../../../hooks/usePreviousState";
import { Tooltip } from 'src/component/Tooltip';
import stickyTableHeader from 'src/helper/stickyTableHeader';
import NavigateToPDP from 'src/component/Global/Product/NavigateToPDP';
import ProductInventoryDisplay from "../../../component/Global/Product/ProductInventoryDisplay";
import Constants from "../../../support/Constants";
import FactoryLeadTimeDisplay from 'src/component/Product/FactoryLeadTimeDisplay';

// DT - 8996 - resolved
// DT - 8419 - add target currency price column
// DT - 8419 - If requested Qty and quoted price is available then only display Qty selection checkbox.
//        If requested Qty is displayed then only display Quoted price 
// DT - when TargetPrice 0 then display "-"
// DT - 1-Feb-23 - 8961: if no product then diplay only mfrPartnumber(no hyperlink)
// DT - 8419 - 7Feb23 - add Fluctuation column 
// DT - resolve bug - data was not loaded
// DT - 9266 - show email button when Pending
// DT - 24/2 - 9377: Checkbox getting disable on No Bid and Expired tab when Requested quantity is available

export function QuoteDetailListTable(props) {
    const [__check] = useAxiosIndicatorCheck();
    const [{ get_current_quote_cart, }, { fetch_line_items }, { toggle_quote_cart_line_item, select_all_quantity }] = useQuoteDetailStore();

    const [list, setList] = useState({});

    const c = System.getParams();
    const quoteNumber = c.quote_number;
    const quoteProvisionalNumber = c.quoteProvisionalNumber;
    const [searchParams] = useSearchParams();
    const [QuoteDetailTabList__Component__Loader] = useReduxState(searchParams.get(CommonQuoteDetail.param_key_QuoteDetailTabList) ? searchParams.get(CommonQuoteDetail.param_key_QuoteDetailTabList) : CommonQuoteDetail.default_component.param_value, CommonQuoteDetail.redux_key_QuoteDetailTabList, true);
    const [currentStatus, set_currentStatus] = useState(CommonQuoteDetail.chain_QuoteDetailTabList[QuoteDetailTabList__Component__Loader].store());
    const [{ filter_list }, { }, { }] = useQuoteFilterSelectionStore();
    const [selectedAllQty, setSelectedAllQty] = useState("");
    const selectedSessionList = get_current_quote_cart();
    const [isFirstCall, setIsFirstCall] = useState(true);
    const [monitorFunctionCall, setMonitorFunctionCall] = useState(false);
    const [listObj, setListObj] = useState({
        pageCount: 0,
        page: 1,
        limit: 20,
        sortBy: '',
        sortOrder: '',
        ascDesField: {}
    });
    const preLimit = usePreviousState(listObj.limit);
    const prePage = usePreviousState(listObj.page);
    const preSortBy = usePreviousState(listObj.sortBy);
    const preSortOrder = usePreviousState(listObj.sortOrder);

    const noRecordMsg = currentStatus?.slug === 'Pending' ? 'All quote lines have been processed. Please check the quote dashboard for details.' : ` Sorry! We can't find any results based on your selection`;


    useEffect(() => {
        window.scrollTo({ top: 0 });
        if (isFirstCall === false && !monitorFunctionCall && !(__check(['LINE_ITEM_API_CALL']).status) && !(__check(['QUOTE_DETAIL_API_CALL']).status)) {
            Helper.monitorJSDx()
            setMonitorFunctionCall(true)
        }
    }, [__check(['LINE_ITEM_API_CALL']).status, __check(['QUOTE_DETAIL_API_CALL']).status])

    useEffect(() => {
        let _selectedQty = new QuoteDetailRepository().setSelectAllQty(currentStatus?.records, selectedSessionList, currentStatus?.slug);
        setSelectedAllQty(_selectedQty)

        if (document.getElementById('table_copy')) {
            for (let i = 1; i <= 3; i++) {
                if (document.getElementsByClassName('chk_qty_' + i).length > 0) {
                    document.getElementsByClassName('chk_qty_' + i)[document.getElementsByClassName('chk_qty_' + i).length - 1].checked = (document.getElementsByClassName('chk_qty_' + i)[document.getElementsByClassName('chk_qty_' + i).length - 1]?.value === _selectedQty ? true : false)
                }
            }
        }

    }, [selectedSessionList, currentStatus, currentStatus?.records]);

    useEffect(() => {
        async function fetchHere() {
            let isIncludeCnt = true;
            if (((preLimit ? preLimit : listObj.limit) !== listObj.limit) || ((prePage ? prePage : listObj.page) !== listObj.page) || ((preSortBy ? preSortBy : listObj.sortBy) !== listObj.sortBy) || ((preSortOrder ? preSortOrder : listObj.sortOrder) !== listObj.sortOrder)) {
                isIncludeCnt = false
            }
            await fetchAPICall(isIncludeCnt)
            set_currentStatus(CommonQuoteDetail.chain_QuoteDetailTabList[QuoteDetailTabList__Component__Loader].store())
        }

        fetchHere();
    }, [listObj.page, listObj.limit, listObj.sortBy, listObj.sortOrder, filter_list, QuoteDetailTabList__Component__Loader]);


    const fetchAPICall = async (isIncludeCnt) => {
        let quoteStatus;
        if (currentStatus?.api_query_param) {
            quoteStatus = currentStatus?.api_query_param;
        } else {
            quoteStatus = CommonQuoteDetail.getCurrentActiveTab(QuoteDetailTabList__Component__Loader);
        }
        await fetch_line_items({
            "quoteNumber": quoteNumber,
            "provisionalId": Helper.valueIsNotNull(quoteProvisionalNumber) ? quoteProvisionalNumber : "",
            "quoteStatus": quoteStatus,
            "pageNumber": listObj.page,
            "pageSize": listObj.limit,
            "sortBy": listObj.sortBy,
            "sortType": listObj.sortOrder,
            "manufacturer": getFilterValue("manufacturer"),
            "manufacturerPartNumber": getFilterValue("manufacturerPartNumber"),
            "customerPartNumber": getFilterValue("customerPartNumber"),
            "includeOtherQuoteCount": isIncludeCnt
        })
        setIsFirstCall(false);
    };

    useEffect(() => {
        if (currentStatus && Object.keys(currentStatus).length > 0) {
            const total = currentStatus.count;
            setList(currentStatus.records)
            setListObj({ ...listObj, pageCount: Math.ceil(total / listObj.limit) })

        }
    }, [currentStatus, currentStatus?.records]);

    const getFilterValue = (key) => {
        let keyword = false;
        if (isArray(filter_list)) {
            keyword = filter_list.find(f => f.searchKey === key)?.searchKeyword;
        }
        return keyword ? keyword : ""
    }

    const handlePageClick = async (data) => {
        let page = Helper.handlePageClick(data, pageCount);
        setListObj({ ...listObj, page: page })
    };

    const setPageLimit = async (event) => {
        setListObj({ ...listObj, limit: event.target.value })
    };

    const onSelectQty = (e, qty, lineItem) => {
        let _item = { ...lineItem };
        if (e.target.checked) {
            _item.quantity_field_selected = qty;
            toggle_quote_cart_line_item(_item)
        } else {
            _item.quantity_field_selected = false;
            toggle_quote_cart_line_item(_item)
        }
    }
    const onSelectAllQty = (e) => {
        const checkedAllQty = e.target.value;
        let data = { quoteNumber: quoteNumber, list: {} }
        if (e.target.checked) {
            let dataList = produceClone(list);
            dataList && Object.entries(dataList).map((v) => {
                if (v[1][`quantity_${checkedAllQty}`] && v[1][`quantity_${checkedAllQty}`] > 0 && v[1]?.product?.ERPPartNumber) {
                    if (currentStatus?.api_query_param === 'A' && v[1][`quotedPrice_${checkedAllQty}`] && v[1][`quotedPrice_${checkedAllQty}`] > 0) {
                        v[1].quantity_field_selected = checkedAllQty;
                    } else {
                        v[1].quantity_field_selected = checkedAllQty;
                    }

                    data.list[v[0]] = v[1];
                }
            });
        }
        if (selectedSessionList && Object.entries(selectedSessionList).length > 0) {
            let selectedList = produceClone(selectedSessionList);
            Object.entries(selectedList).map((v) => {
                if (v[1].status !== currentStatus?.slug)
                    data.list[v[0]] = v[1];
            });
        }

        select_all_quantity(data);
    }

    const refreshStock = async () => {
        await new ProductInventoryRepository().refreshAllProductInventoryRunTimeAvailable()
    }

    const disableQtyChk = (item, qty, quotedPrice) => {
        let result = false
        if (currentStatus?.api_query_param !== 'P' && item[1]?.product?.ERPPartNumber) {
            if (qty && qty > 0) {
                result = true;
                if (currentStatus?.api_query_param === 'A') {
                    result = (quotedPrice && quotedPrice > 0);
                }
            }
        }

        return result;
    }

    const getOrderByClass = (columnName) => {
        if (listObj.sortBy === columnName && listObj.ascDesField.hasOwnProperty(columnName)) {
            return 'sorting sorting_' + listObj.ascDesField[columnName].toLowerCase()
        }
        return 'sorting'
    };

    const toggleOrderBy = async (columnName) => {
        if (listObj.ascDesField.hasOwnProperty(columnName)) {
            listObj.ascDesField[columnName] = listObj.ascDesField[columnName] === 'ASC' ? 'DESC' : 'ASC'
            setListObj({ ...listObj, ascDesField: listObj.ascDesField })

        } else {
            listObj.ascDesField[columnName] = 'ASC'
            setListObj({ ...listObj, ascDesField: listObj.ascDesField })

        }
        setListObj({ ...listObj, sortBy: columnName, sortOrder: listObj.ascDesField[columnName] })
    };

    useEffect(() => {

        let isDisplayFixedHeader;
        let refreshStockButton;
        let callback;

        if ((isObject(list) && Object.entries(list).length > 0)) {
            const sort = toggleOrderBy;
            const tableElement = document?.getElementById("quotedetail-table");
            // headerHeght contains height where we need to display static header
            // local
            // const headerHeight =  document?.getElementsByTagName("header") ? document?.getElementsByTagName("header")[0]?.clientHeight :65;
            //sbx
            let headerHeight = document?.getElementsByClassName("navbar navbar-default white") ? document?.getElementsByClassName("navbar-default")[0]?.clientHeight + 1 : 156;

            // Admin Toolbar header height adjustment
            const adminToolBarHeight = document?.getElementsByClassName("wpToolbarActionBar wpToolbarCommon")?.length > 0 ? document?.getElementsByClassName("wpToolbarActionBar wpToolbarCommon")[0]?.clientHeight : 0;

            if (adminToolBarHeight > 0) {
                headerHeight = headerHeight + adminToolBarHeight;
            }
            // is used to track only one header will display at a moment
            // extra function attach 
            document.addEventListener("scroll", (ScrollEvent) => {
                // current table position from top
                const tablePosition = tableElement && tableElement.getBoundingClientRect() ? tableElement.getBoundingClientRect().y : false;
                const paginationPosition = document?.querySelectorAll("div.pagination-row") ? document?.querySelectorAll("div.pagination-row")[0]?.getBoundingClientRect()?.y : false;

                if (tablePosition && headerHeight > tablePosition && isNaN(paginationPosition) === false && (Number(headerHeight) + 40 <= Number(paginationPosition)) && !isDisplayFixedHeader) {
                    //function used to display header clone after actual header height is less than headerHeight from top
                    if (!document.getElementById("table_copy")) {
                        callback = stickyTableHeader("quotedetail-table", headerHeight, "sticky-table-wrapper", 1, sort)
                        isDisplayFixedHeader = true;
                        refreshStockButton = document.getElementsByClassName("refresh-link")
                        refreshStockButton[1].addEventListener("click", refreshStock);
                        for (let i = 1; i <= 3; i++) {
                            if (document.getElementsByClassName('chk_qty_' + i).length > 0 && onSelectAllQty) {
                                document.getElementsByClassName('chk_qty_' + i)[document.getElementsByClassName('chk_qty_' + i).length - 1]?.addEventListener("change", (evt) => onSelectAllQty(evt));
                            }
                        }
                    }
                } else {
                    if ((headerHeight < tablePosition || (Number(paginationPosition) <= Number(headerHeight) + 40)) && isDisplayFixedHeader && callback) {
                        // switch variable to false for track that clone header hide
                        isDisplayFixedHeader = false;
                        // check element exist before remove event listeners
                        if (refreshStockButton && refreshStockButton[1] && refreshStock) {
                            refreshStockButton[1]?.removeEventListener("click", refreshStock);
                        }
                        // check element exist before remove event listeners
                        for (let i = 1; i <= 3; i++) {
                            if (document.getElementsByClassName('chk_qty_' + i).length > 0 && onSelectAllQty) {
                                document.getElementsByClassName('chk_qty_' + i)[document.getElementsByClassName('chk_qty_' + i).length - 1]?.removeEventListener("change", onSelectAllQty);
                            }
                        }
                        // function used to remove the clone header
                        if (Object.prototype.toString.call(callback) == '[object Function]') {
                            callback();
                        }
                    }
                }
            })
            return () => {
                if (callback) {
                    // switch variable to false for track that clone header hide
                    isDisplayFixedHeader = false;
                    // check element exist before remove event listeners
                    if (refreshStockButton && refreshStockButton[1] && refreshStock) {
                        refreshStockButton[1]?.removeEventListener("click", refreshStock);
                    }
                    // check element exist before remove event listeners
                    for (let i = 1; i <= 3; i++) {
                        if (document.getElementsByClassName('chk_qty_' + i).length > 0 && onSelectAllQty) {
                            document.getElementsByClassName('chk_qty_' + i)[document.getElementsByClassName('chk_qty_' + i).length - 1]?.removeEventListener("change", onSelectAllQty);
                        }
                    }

                    // function used to remove the clone header
                    callback();
                    //window.scrollTo(0, 0)
                }
            }
        }
    }, [list, __check(['LINE_ITEM_API_CALL']).status])

    return (
        <>
            <div className="tab-content p-0">
                {__check(['LINE_ITEM_API_CALL']).render}
                {(!__check(['LINE_ITEM_API_CALL']).status && !__check(['QUOTE_DETAIL_API_CALL']).status) &&
                    <>
                        {(isObject(list) && Object.entries(list).length > 0) ?
                            <div id="tab1" className="tab-pane active table-container">
                                <div id='sticky-table-wrapper' className="table-responsive sticky-table-wrapper">
                                    <table id='quotedetail-table' className="bs5 table table-bordered search-products-table customer-quote-table ">
                                        <thead>
                                            <tr>
                                                <th className="w-95 minw-100"></th>
                                                <th aria-label='mfrpartnumber' className={`minw280 ${getOrderByClass('mfrpartnumber')}`} onClick={async () => { await toggleOrderBy('mfrpartnumber') }}> Part Information</th>
                                                <th aria-label='targetprice' className={`${getOrderByClass('targetprice')}`} onClick={async () => { await toggleOrderBy('targetprice') }}>Target Price</th>
                                                {(currentStatus?.slug === 'Approved' || currentStatus?.slug === 'Booking') && <th>Currency Fluctuation</th>}
                                                <th>
                                                    <div className="checkbox"><label className="text-nowrap">
                                                        {/* 9209 - tusharkc - adding a condition, to check if the current tab is not pending tab.*/}

                                                        {currentStatus?.api_query_param !== 'P' &&
                                                            <input type="checkbox" value="quantity_1"
                                                                className='chk_qty_1'
                                                                onClick={(e) => onSelectAllQty(e)}
                                                                checked={selectedAllQty === "quantity_1"}
                                                                onChange={e => { }}
                                                            />
                                                        }Quantity 1</label>
                                                    </div>
                                                </th>
                                                <th>
                                                    <div className="checkbox">
                                                        <label className="text-nowrap">
                                                            {currentStatus?.api_query_param !== 'P' &&
                                                                <input type="checkbox" value="quantity_2"
                                                                    className='chk_qty_2'
                                                                    onClick={(e) => onSelectAllQty(e)}
                                                                    checked={selectedAllQty === "quantity_2"}
                                                                    onChange={e => { }}
                                                                />}Quantity 2</label>
                                                    </div>
                                                </th>
                                                <th>
                                                    <div className="checkbox"><label className="text-nowrap">
                                                        {currentStatus?.api_query_param !== 'P' &&
                                                            <input type="checkbox" value="quantity_3"
                                                                className='chk_qty_3'
                                                                onClick={(e) => onSelectAllQty(e)}
                                                                checked={selectedAllQty === "quantity_3"}
                                                                onChange={e => { }}
                                                            />
                                                        }Quantity 3</label>
                                                    </div>
                                                </th>

                                                <th className="minw230">Availability
                                                    <RefreshStockButton fetchInventoryFromServer={refreshStock} />
                                                </th>
                                                <th className="minw280">COMMENTS</th>
                                                <th>Description</th>
                                                <th>End Customer</th>
                                                <th>Information</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {Object.entries(list).map((ele, i) => (
                                                <tr key={ele[0]}>
                                                    <td>
                                                        <a href={void (0)} onClick={() => {
                                                            store.dispatch(system_notification({
                                                                name: 'QuoteMessagePopup',
                                                                data: {
                                                                    single_quote_detail_item: ele[1],
                                                                    single_quote_detail: ele[1],
                                                                },
                                                            }));
                                                        }}>
                                                            <Tooltip position={'right'}
                                                                opener={() => (<i className="fa fa-envelope text-blue font-16" aria-hidden="true"></i>)}
                                                                content={() => (
                                                                    <div>
                                                                        Click to send a question or comment to your sales representative.
                                                                    </div>
                                                                )}
                                                            />
                                                        </a>
                                                    </td>

                                                    <td className="partnumber-detail">
                                                        <div>
                                                            <label>Manufacturer: </label>
                                                            <span>{ele[1].product !== undefined && ele[1].product !== null && Helper.valueIsNotNull(ele[1].product.ManufacturerName) ? ele[1].product.ManufacturerName : (ele[1].manufacturerName.trim() ? ele[1].manufacturerName : '')}</span>
                                                        </div>

                                                        <div>
                                                            <label>Mfg Part #: </label>
                                                            {ele[1].product?.ERPMFRPartNumber ?
                                                                <NavigateToPDP data={{
                                                                    ManufacturerName: ele[1]?.product?.ManufacturerName,
                                                                    ERPMFRPartNumber: ele[1]?.product?.ERPMFRPartNumber,
                                                                    ItemNumber: ele[1]?.product?.ItemNumber,
                                                                }}>
                                                                    <div className="text-blue">
                                                                        <b>{ele[1].product?.ERPMFRPartNumber}</b>
                                                                    </div>
                                                                </NavigateToPDP>
                                                                : ele[1].erpManufacturerPartNumber}
                                                        </div>

                                                        {(ele[1].customerPartNumber.trim() && ele[1].customerPartNumber !== "*") && <div>
                                                            <label>Customer Part #:</label>
                                                            <span>{ele[1].customerPartNumber}</span>
                                                        </div>}
                                                    </td>
                                                    <td>{(ele[1]?.targetPrice && ele[1]?.targetPrice > 0) ? Helper.getFormatNumber(ele[1]?.targetPrice, ele[1]?.targetCurrency, true, 5) : '——'}</td>
                                                    {(currentStatus?.slug === 'Approved' || currentStatus?.slug === 'Booking') && <td>{ele[1]?.currencyFluctuation ? ele[1]?.currencyFluctuation : '——'}</td>}

                                                    <td>
                                                        <div>
                                                            <label>Requested Qty:</label>
                                                            {ele[1].isValid_quantity_1 === false ?
                                                                <span className="red-txt">{ele[1].quantity_quantity_1}*</span> :
                                                                <span> {ele[1].quantity_quantity_1} </span>
                                                            }
                                                        </div>
                                                        {/* tusharKc - 9210 - hiding quoted price on no bid and expired tab */}
                                                        {(currentStatus?.api_query_param != "E" && currentStatus?.api_query_param != "B" && currentStatus?.api_query_param != "P") &&
                                                            <div>
                                                                <label>Quoted Price: </label><span> {Helper.getFormatNumber(ele[1]?.quotedPrice_quantity_1, ele[1]?.currency_quantity_1, true, 5)} </span>
                                                            </div>
                                                        }
                                                        {currentStatus?.api_query_param !== 'P' && <>
                                                            <div
                                                                className={disableQtyChk(ele, ele[1].quantity_quantity_1, ele[1]?.quotedPrice_quantity_1) ? 'checkbox' : 'checkbox disable'}>
                                                                <label className="text-blue">
                                                                    <input type="checkbox"
                                                                        name={`qty1_${i}`}
                                                                        disabled={!disableQtyChk(ele, ele[1].quantity_quantity_1, ele[1]?.quotedPrice_quantity_1)}
                                                                        checked={CommonQuoteDetail.getSelectedQtyStrFromQuoteCartSession(ele[1].quoteNumber, ele[1].uniqueLineItem, 'quantity_1')}
                                                                        onClick={(e) => onSelectQty(e, 'quantity_1', ele[1])}
                                                                        onChange={e => { }}
                                                                    />Select
                                                                    qty 1
                                                                </label>
                                                            </div>
                                                        </>}
                                                    </td>
                                                    <td>
                                                        <div><label>Requested Qty:</label>
                                                            {ele[1].isValid_quantity_2 === false ?
                                                                <span className="red-txt">{ele[1].quantity_quantity_2}*</span> :
                                                                <span> {ele[1].quantity_quantity_2 > 0 ? ele[1].quantity_quantity_2 : '——'} </span>
                                                            }
                                                        </div>

                                                        {ele[1].quantity_quantity_2 > 0 && (currentStatus?.api_query_param != "E" && currentStatus?.api_query_param != "B" && currentStatus?.api_query_param != "P") &&
                                                            <div>
                                                                <label>Quoted Price: </label>
                                                                <span>{ele[1]?.quotedPrice_quantity_2 ? Helper.getFormatNumber(ele[1]?.quotedPrice_quantity_2, ele[1]?.currency_quantity_2, true, 5) : '——'} </span>
                                                            </div>
                                                        }

                                                        {currentStatus?.api_query_param !== 'P' &&
                                                            <div className={disableQtyChk(ele, ele[1].quantity_quantity_2, ele[1]?.quotedPrice_quantity_2) ? 'checkbox' : 'checkbox disable'}>
                                                                <label className="text-blue">
                                                                    <input type="checkbox"
                                                                        disabled={!disableQtyChk(ele, ele[1].quantity_quantity_2, ele[1]?.quotedPrice_quantity_2)}
                                                                        name={`qty2_${i}`}
                                                                        checked={CommonQuoteDetail.getSelectedQtyStrFromQuoteCartSession(ele[1].quoteNumber, ele[1].uniqueLineItem, 'quantity_2')}
                                                                        onClick={(e) => onSelectQty(e, 'quantity_2', ele[1])}
                                                                        onChange={e => { }} />
                                                                    Select qty 2
                                                                </label>
                                                            </div>
                                                        }
                                                    </td>
                                                    <td>
                                                        <div>
                                                            <label>Requested Qty:</label>
                                                            {ele[1].isValid_quantity_3 === false ?
                                                                <span className="red-txt">{ele[1].quantity_quantity_3}*</span> :
                                                                <span> {ele[1].quantity_quantity_3 > 0 ? ele[1].quantity_quantity_3 : '——'} </span>
                                                            }
                                                        </div>
                                                        {ele[1].quantity_quantity_3 > 0 && (currentStatus?.api_query_param != "E" && currentStatus?.api_query_param != "B" && currentStatus?.api_query_param != "P") &&
                                                            <div>
                                                                <label>Quoted Price: </label>
                                                                <span>{ele[1]?.quotedPrice_quantity_3 ? Helper.getFormatNumber(ele[1]?.quotedPrice_quantity_3, ele[1]?.currency_quantity_3, true, 5) : '——'} </span>
                                                            </div>
                                                        }
                                                        {currentStatus?.api_query_param !== 'P' &&
                                                            <div className={disableQtyChk(ele, ele[1].quantity_quantity_3, ele[1]?.quotedPrice_quantity_3) ? 'checkbox' : 'checkbox disable'}>
                                                                <label className="text-blue">
                                                                    <input type="checkbox"
                                                                        name={`qty3_${i}`}
                                                                        disabled={!disableQtyChk(ele, ele[1].quantity_quantity_3, ele[1]?.quotedPrice_quantity_3)}
                                                                        checked={CommonQuoteDetail.getSelectedQtyStrFromQuoteCartSession(ele[1].quoteNumber, ele[1].uniqueLineItem, 'quantity_3')}
                                                                        onClick={(e) => onSelectQty(e, 'quantity_3', ele[1])}
                                                                        onChange={e => { }} />Select
                                                                    qty 3
                                                                </label>
                                                            </div>
                                                        }
                                                    </td>

                                                    <td>
                                                        {__check(['PRODUCT_INVENTORY_API_CALL']).render}
                                                        {!__check(['PRODUCT_INVENTORY_API_CALL']).status &&
                                                            // <ProductInventoryDisplay single_product={ele[1].product} isFrom={Constants.isFrom.QUOTE_DETAIL} single_product_inventory={ele[1].product?.assets?.inventory} />
                                                            <>
                                                                <div className="text-darkgreen  d-flex align-items-center">
                                                                    <i className="fa fa-check-circle me-1"></i>
                                                                    <span className="d-flex text-darkgreen w-100">
                                                                        <b>In Stock</b>
                                                                        <b className="ms-auto">{isNumber(ele[1].product?.assets?.inventory.qas) && ele[1].product?.assets?.inventory.qas > 0 ? ele[1].product?.assets?.inventory.qas : ele[1].product?.assets?.inventory.qas}</b>
                                                                        <i style={{ visibility: __check(['PRODUCT_INVENTORY_API_CALL']).status ? 'hidden' : 'visible' }}
                                                                            className="fa fa-check-circle ms-2"></i>
                                                                    </span>
                                                                </div>
                                                                <div id="availability_cont_3_lead_time" className="grey">
                                                                    <div className="addtn-inventory leadTime">
                                                                        <strong>ADDITIONAL INVENTORY</strong>
                                                                        <div className="clearfix">
                                                                            <FactoryLeadTimeDisplay
                                                                                single_product={ele[1].product}
                                                                                single_product_inventory={ele[1].product?.assets?.inventory} />
                                                                        </div>
                                                                        {(ele[1]?.product?.Min && ele[1]?.product?.Mult) &&
                                                                            <span className={`${(ele[1].quantity_quantity_1 === false || ele[1].quantity_quantity_2 === false || ele[1].quantity_quantity_3 === false) ? 'red-txt' : ''}`} >Min/Mult: {ele[1].product.Min}/{ele[1].product.Mult}</span>
                                                                        }
                                                                    </div>
                                                                </div>
                                                            </>
                                                        }
                                                    </td>
                                                    <td>
                                                        {/* DT - 11/9 - 10811 */}
                                                        {ele[1]?.avnetComment ?
                                                            <p dangerouslySetInnerHTML={{ __html: ele[1].avnetComment.replaceAll("|||", '</br>') }}></p> : null
                                                        }
                                                    </td>
                                                    <td>
                                                        {ele[1].product?.ShortDescription && ele[1].product?.ShortDescription !== undefined && ele[1].product?.ShortDescription !== null && ele[1].product?.ShortDescription.trim() != '' ?
                                                            <ShowMoreLess single_product={ele[1].product} /> : '——'}
                                                    </td>
                                                    <td>
                                                        {ele[1].endCustomerName && ele[1].endCustomerName.trim() ? ele[1].endCustomerName : '——'}
                                                    </td>
                                                    <td>
                                                        <div className='bs5'>
                                                            <ul className="list-text plp-info-ledgend">
                                                                <ProductLegends
                                                                    single_product={ele[1].product}
                                                                    onlyIconTitle={true}
                                                                />
                                                            </ul>

                                                        </div>
                                                    </td>
                                                </tr>
                                            ))}
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                            :
                            <div className='mt-2'>
                                <NoResultContent message={noRecordMsg} isDisplay={false} />
                            </div>

                        }
                    </>
                }
            </div>
            {
                isObject(list) && Object.entries(list).length > 0 &&
                <Pagination pageCount={listObj.pageCount} handlePageClick={handlePageClick} setPageLimit={setPageLimit} page={listObj.page - 1}
                    limit={listObj.limit} />
            }
        </>
    );

}
